import { Delay } from '../utils/delay';

export default {
  listen: {
    value: function() {
      return Delay.waitInMs(this.triggerInfo.delay * 1000 || 0);
    }
  }
};
